<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">Admission Procedure</h4>
                    <div class="card-body text-justify">
                        <p class="lead text-justify inner-lead fw-bold">Admission to the school is open to children of
                            all sections of society. The age criteria for the children seeking admission to:</p>
                        <ul>
                            <li>
                                <p class="inner-lead">Class Nursery : 3+ as on March 31, 2024.</p>
                            </li>
                            <li>
                                <p class="inner-lead">Class LKG : 4+ as on March 31, 2024.</p>
                            </li>
                            <li>
                                <p class="inner-lead">Class UKG : 5+ as on March 31, 2024.</p>
                            </li>
                            <li>
                                <p class="inner-lead">Class 1<sup>st</sup> : 6+ as on September 30, 2024.</p>
                            </li>
                        </ul>
                        <br>
                        <p class="inner-lead">Admission to all classes is subject to the availability of seats and
                            satisfactory performance in a screening test. The students seeking admission to all classes,
                            except class Nursery, will be tested in the following subjects:</p>
                        <ul>
                            <li>
                                <p class="inner-lead">Classes LKG to IV : English, Hindi (Grammar and Composition) and
                                    Maths</p>
                            </li>
                            <li>
                                <p class="inner-lead">Classes V to VIII : English (Grammar and Composition) Maths and
                                    Science</p>
                            </li>
                            <li>
                                <p class="inner-lead">Class XI :</p>
                            </li>
                            <ul>
                                <li>
                                    <p class="inner-lead">For Science Stream : English, Mathematics, Science</p>
                                </li>
                                <li>
                                    <p class="inner-lead">For Commerce Stream : English, Mathematics & Economics</p>
                                </li>
                                <li>
                                    <p class="inner-lead">For Arts Stream : English, Social Science and Mathematics
                                        (Optional)</p>
                                </li>
                            </ul>
                        </ul>
                        <br>
                        <p class="inner-lead">The admission form should have the following documents attached:</p>
                        <ol>
                            <li>
                                <p class="inner-lead">Copy of Birth Certificate (Hospital/Municipal Committee/Village Panchayat)</p>
                            </li>
                            <li>
                                <p class="inner-lead">School Leaving Certificate of previous school</p>
                            </li>
                            <li>
                                <p class="inner-lead">Report Card of previous class</p>
                            </li>
                            <li>
                                <p class="inner-lead">Student Registration Number (SRN)</p>
                            </li>
                            <li>
                                <p class="inner-lead">Copies of Aadhaar Cards of the Student, Father & Mother</p>
                            </li>
                            <li>
                                <p class="inner-lead">Copy of Family ID.</p>
                            </li>
                        </ol>
                        <p class="inner-lead">The Principal reserves the right to refuse admission without assigning any
                            reason.
                        </p>
                        <h4 class="card-title"> Withdrawals</h4>
                        <ol>
                            <li>
                                <p class="inner-lead">Students can be withdrawn from the school by giving one month’s
                                    notice. In the absence of such a notice, one-month’s fee will be charged. No
                                    transfer certificate will be issued until all the dues are cleared.</p>
                            </li>
                            <li>
                                <p class="inner-lead"> If the result is consistently poor for two years, the student can
                                    be asked to leave the school.</p>
                            </li>
                            <li>
                                <p class="inner-lead">The school authorities reserve the right to dismiss those students
                                    who fail to maintain the discipline of the school.</p>
                            </li>
                        </ol>

                        <h4 class="card-title"> Important Note</h4>
                        <ol>
                            <li>
                                <p class="inner-lead">Bus facility is provided for the whole session. Request for
                                    seeking or discontinuation of the same in the mid of the session cannot be granted.
                                </p>
                            </li>
                            <li>
                                <p class="inner-lead">Students are not allowed to bring mobile phones, valuable articles
                                    or cash to school.</p>
                            </li>
                            <li>
                                <p class="inner-lead">Students are not allowed to receive visitors or phone calls during
                                    school hours except in case of an emergency. Verbal request to allow children to go
                                    home before time will not be accepted.</p>
                            </li>
                            <li>
                                <p class="inner-lead">Every student is expected to take care of the school property. He
                                    will have to pay for any damage he does to school property or anything belonging to
                                    the fellow students.</p>
                            </li>
                            <li>
                                <p class="inner-lead">Disobedience or conduct injurious to discipline of the school will
                                    be dealt seriously.</p>
                            </li>
                            <li>
                                <p class="inner-lead">Regularity and punctuality are essential. Absence without an
                                    application will invite a fine of Rs 10 per day.</p>
                            </li>
                            <li>
                                <p class="inner-lead">Right to amend rules is reserved by the Managing Committee of the school.</p>
                            </li>
                        </ol>

                    </div>
                </div>

            </div>
        </div>


    </div>
</div>